import { api } from "../api";

export const fetchContract = async (contractURL: string) => {
  try {
    const res = await api.get("/api/fetch-user-contract", {
      params: { contractURL },
    });
    if (res.status === 200) {
      return res.data.contract;
    }
  } catch (err: any) {
    console.error(
      "FetchingUserContractFailed",
      err.response?.data || err.message
    );
    return null;
  }
};
